export default __webpack_public_path__ + "static/media/screenshot18.e217aaf7.jpg";